module.exports = __webpack_public_path__ + "static/media/ivan_k.287739de.jpg";